import { Box, Drawer } from '@mui/material';
import { bool, object, string } from 'prop-types';
import React, { useRef } from 'react';
import useEventListener from 'utils/useEventListener';
import CloseButton from '../CloseButton';

import connector from './connector';

const RemoteDrawer = ({ url = null, actions, isOpen }) => {
  const iframeRef = useRef(null);

  useEventListener('message', e => {
    // Trust the active config iframe only (may be API redirect → web SPA or custom configPageUrl).
    if (!iframeRef.current || e.source !== iframeRef.current.contentWindow) {
      return;
    }
    if (e.data === 'close-drawer' || e.message === 'close-drawer') {
      actions.drawers.remote.close();
    }
  });

  return (
    <Drawer anchor="right" open={isOpen} onClose={actions.drawers.remote.close}>
      <Box
        sx={theme => ({
          display: 'flex',
          width: '90vw',
          height: '100%',
          [theme.breakpoints.up('md')]: {
            width: 1000,
          },
        })}
      >
        <Box sx={{ paddingTop: '20px', paddingLeft: '20px' }}>
          <CloseButton onClick={actions.drawers.remote.close} />
        </Box>
        {url ? (
          <iframe
            ref={iframeRef}
            title="config"
            src={url}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        ) : null}
      </Box>
    </Drawer>
  );
};

RemoteDrawer.propTypes = {
  url: string,
  actions: object.isRequired,
  isOpen: bool.isRequired,
};

export default connector(RemoteDrawer);
